import { create } from 'lodash'
import { titleCase } from '../../utils/general'

export const createContainerStateObject = (order) => {
  const newCompartments = []
  order.compartments.forEach((c) => {
    const fixedCompartment = { ...c }
    fixedCompartment.targets = []
    c.targets.forEach((t) => fixedCompartment.targets.push({ ...t }))
    fixedCompartment.volume = fixedCompartment.targets[0]?.volume
    newCompartments.push(fixedCompartment)
  })
  return newCompartments
}
export const getMultiStoreOptions = (orderDestinations, product, currentStores) => {
  const destCopy = [...orderDestinations]
  return destCopy.filter(
    (d) =>
      !currentStores.includes(d.store_number) && d.tanks.some((t) => product.toUpperCase() === t.product.toUpperCase())
  )
}
export const addImpactToTanks = (store, order) => {
  const affectedTankStore = order.affected_tanks.find(
    (affectedStore) => store.store_number.localeCompare(affectedStore.store, undefined, { sensitivity: 'base' }) === 0
  )
  if (affectedTankStore) {
    affectedTankStore.tanks.forEach((affectedTank) => {
      store.grouped_tanks.forEach((tankGroup) => {
        const tankMatch = tankGroup.tanks.find((tank) => tank.tank_id === affectedTank.tank_id)
        const manifoldMatch = tankGroup.manifold_tanks.find((manifold) =>
          manifold.tanks.some((manifoldTank) => manifoldTank.tank_id === affectedTank.tank_id)
        )

        if (tankMatch) {
          tankMatch.projected_volume = affectedTank.projected_volume
          tankMatch.projected_percent_filled = affectedTank.projected_percent_filled
        }
        if (manifoldMatch) {
          const manifoldTank = manifoldMatch.tanks.find((manifoldTank) => manifoldTank.tank_id === affectedTank.tank_id)
          if (manifoldTank) {
            manifoldTank.projected_volume = affectedTank.projected_volume
            manifoldTank.projected_percent_filled = affectedTank.projected_percent_filled
          }
        }
      })
    })
  }
}
export const getApiFiltersToSend = (terminalFilter, supplierFilter, priceTypeFilter) => {
  const sendFilters = {}
  const trueTerminals = terminalFilter.filterValues.filter((value) => value.value)
  sendFilters.terminals = trueTerminals.map((terminal) => terminal.label)
  const trueSuppliers = supplierFilter.filterValues.filter((value) => value.value)
  sendFilters.suppliers = trueSuppliers.map((supplier) => supplier.label)
  const truePriceTypes = priceTypeFilter.filterValues.filter((value) => value.value)
  sendFilters.price_types = truePriceTypes.map((priceType) => priceType.label)
  sendFilters.price_options = 3

  return sendFilters
}
export const createSupplyFilter = (accessor, supplyFilters, initialSupplyFilters) => {
  const sentFilter = supplyFilters[accessor]
  if (!sentFilter) {
    return null
  }

  let filterValues
  const initialFilter = initialSupplyFilters?.[accessor]
  //Check if initial filters exist, if so mark initial filters true and everything else false
  if (initialFilter) {
    const selectedValues = initialFilter.map((option) => createOption(true, option))
    const unSelectedValues = sentFilter
      .filter((option) => !initialFilter.includes(option))
      .map((option) => createOption(false, option))
    filterValues = selectedValues.concat(unSelectedValues)
  } else {
    //If no initial filters exist, mark all filters true
    filterValues = sentFilter.map((option) => createOption(true, option))
  }

  return {
    title: titleCase(accessor),
    accessor: accessor,
    filterValues,
  }

  return {
    title: titleCase(accessor),
    accessor: accessor,
    filterValues,
  }
}

function createOption(selected, label) {
  return {
    label,
    value: selected,
    display: true,
  }
}

export const isTruckLoaded = (status) => {
  const loadedStatuses = ['driving to drop', 'arrived at drop', 'dropping', 'heading home']
  return loadedStatuses.includes(status)
}
export const addFlagsToSupply = (order) => {
  const supplyCopy = { ...order.supply_option }
  if (order.flags && order.flags.length > 0) {
    const unavailableFlag = order.flags.find((f) => f.type === 'supply_option')
    const subOptimalFlag = order.flags.find((f) => f.type === 'optimal_supply')
    if (unavailableFlag) {
      supplyCopy.missingStatus = unavailableFlag.details[0].value
    } else if (subOptimalFlag) {
      supplyCopy.priceDifference = subOptimalFlag.details[0].value
      supplyCopy.optimalTerminal = subOptimalFlag.details[1].value
      if (subOptimalFlag.severity === 'money') {
        supplyCopy.loadedMiles = subOptimalFlag.details[2].value
      }
    }
  }
  return supplyCopy
}
